import * as i0 from '@angular/core';
import { Directive, Input, HostListener, NgModule } from '@angular/core';

class NgxScrollToFirstInvalidDirective {
    constructor(el) {
        this.el = el;
        this.formGroup = null;
    }
    static scrollToElement(element) {
        if (element) {
            const distance = window.pageYOffset - Math.abs(element.getBoundingClientRect().y);
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: element.getBoundingClientRect().top + window.scrollY - 150,
            });
            setTimeout(() => {
                element.focus();
                element.blur(); // Trigger error messages
                element.focus();
            }, distance);
        }
    }
    static markFormGroupTouched(formGroup) {
        Object.values(formGroup?.controls).forEach((control) => {
            control.markAsTouched();
            if (control.controls) {
                NgxScrollToFirstInvalidDirective.markFormGroupTouched(control);
            }
        });
    }
    onSubmit(event) {
        event.preventDefault();
        if (!this.formGroup?.valid) {
            NgxScrollToFirstInvalidDirective.markFormGroupTouched(this.formGroup);
            const formControlInvalid = this.el.nativeElement.querySelector('.ng-invalid');
            if (formControlInvalid) {
                return NgxScrollToFirstInvalidDirective.scrollToElement(formControlInvalid);
            }
            else {
                // The first element is the global form and here we are looking for the first nested form
                const formGroupInvalid = this.el.nativeElement.querySelectorAll('form .ng-invalid');
                if (formGroupInvalid && formGroupInvalid.length) {
                    return NgxScrollToFirstInvalidDirective.scrollToElement(formGroupInvalid[0]);
                }
            }
            return NgxScrollToFirstInvalidDirective.scrollToElement(this.el.nativeElement);
        }
    }
}
NgxScrollToFirstInvalidDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
NgxScrollToFirstInvalidDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.1.5", type: NgxScrollToFirstInvalidDirective, selector: "[ngxScrollToFirstInvalid]", inputs: { formGroup: "formGroup" }, host: { listeners: { "submit": "onSubmit($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[ngxScrollToFirstInvalid]' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { formGroup: [{
                type: Input
            }], onSubmit: [{
                type: HostListener,
                args: ['submit', ['$event']]
            }] } });

class NgxScrollToFirstInvalidModule {
}
NgxScrollToFirstInvalidModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxScrollToFirstInvalidModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidModule, declarations: [NgxScrollToFirstInvalidDirective], exports: [NgxScrollToFirstInvalidDirective] });
NgxScrollToFirstInvalidModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: NgxScrollToFirstInvalidModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgxScrollToFirstInvalidDirective],
                    exports: [NgxScrollToFirstInvalidDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NgxScrollToFirstInvalidDirective, NgxScrollToFirstInvalidModule };
